<template>
  <div
    class="lg:px-16 md:px-12 px-5 lg:py-12 md:py-12 py-8 grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-5"
  >
    <div
      class="cust-shadow1 p-3 rounded-md bg-fff"
      v-for="(campaign, index) in campaignHome.result"
      :key="index"
    >
      <!-- {{ campaign.heading }} -->
      <!-- src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg" -->
      <img
        :src="$imageURL + '/' + campaign.image"
        alt="img"
        class="w-full lg:h-64 md:h-64 h-52 rounded-lg"
      />
      <p class="font-semibold fsize18 sm-fsize16 text-black pt-2">
        {{ campaign.heading }}
      </p>
      <div class="flex justify-between text-black sm-fsize14 mt-1">
        <p class="flex items-center gap-1">
          <feather-icon
            icon="CalendarIcon"
            svgClasses="w-5 h-5"
            class="text-primary"
          />
          <strong>Date:</strong> {{ formatDate(campaign.startDate) }} -
          {{ formatDate(campaign.endDate) }}
        </p>
        <!-- <p><strong>To:</strong> </p> -->
      </div>
      <!-- <p class="sm-fsize14 text-black">Total Events : 4</p> -->
      <button
        class="bg-primary clr-fff fsize12 font-semibold px-6 py-1 rounded-full mt-2"
        @click="handleCamppaighClick('campaign-user', campaign._id)"
      >
        View
      </button>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
  },

  methods: {
    formatDate(date) {
      if (!date) return "N/A";
      // return new Date(date).toLocaleDateString("en-GB");
      return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    handleCamppaighClick(name, id) {
      this.$router.push({
        name: name,
        params: { id: btoa(id) },
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("campaignPageBanner/get_campaignhome");
    // console.log("campaignHome length:", this.campaignHome.result.length);
  },
};
</script>
